document.addEventListener('DOMContentLoaded', async () => {
  console.log('Loaded');

  const cont = document.querySelectorAll('.product-card');

  await fetch('/cart.js', {
    method: 'GET',
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((data) => {
      console.log('Cart data->', data);
      data.items.forEach((d, idx) => {
        cont.forEach((c) => {
          const variant_id = c.querySelector('#variant-id');
          const addToCartForm = c.querySelector('form[action="/cart/add"]');
          const quantityContainer = c.querySelector('.quantity-container');
          const priceTag = c.querySelector('.price-tag');
          const quantity_input = c.querySelector('.quantity_input');
          if (d.id === parseInt(variant_id.getAttribute("data-variant-id"))) {
            addToCartForm.style.display = 'none';
            addToCartForm.querySelector('.id-holder-input').setAttribute('data-key', d.key);
            quantityContainer.style.display = 'flex';
            priceTag.style.visibility = 'visible';
            quantity_input.innerHTML = d.quantity;
          }
        });
      });

      if (window.updateCartDrawer) {
        window.updateCartDrawer();
      }
    })
    .catch((error) => {
      console.error('There was a problem with the fetch operation:', error);
    });

  // Setup event listeners for each product card
  cont.forEach((c) => {
    const plus = c.querySelector('.plus');
    const minus = c.querySelector('.minus');
    const quantity_input = c.querySelector('.quantity_input');
    const addToCartForm = c.querySelector('form[action="/cart/add"]');
    const quantityContainer = c.querySelector('.quantity-container');
    const priceTag = c.querySelector('.price-tag');
    const id = c.querySelector('#variant-id');
    const alertBox = c.querySelector('.shop-alert-box');
    let isApiCallInProgress = false;

    // Handle add to cart form submission
    addToCartForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      // const form_data = new FormData(addToCartForm);
      // form_data.append('quantity', 1);

      // await fetch('/cart/add.js', {
      //   method: 'post',
      //   body: form_data,
      // })
      try {
        const variantId = addToCartForm.querySelector('.id-holder-input')?.value;
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        const data = await window.addToCart(formData, false);
        console.log('the key is:', data.key);
        addToCartForm.querySelector('.id-holder-input').setAttribute('data-key', data.key);

        if (data.quantity === 1) {
          const productName = data.title || data.product_title || 'Product';
          const productImage =
            data.image || (data.featured_image && data.featured_image.url) || '/path/to/default/image.jpg';

          const event = new CustomEvent('cart:added', {
            detail: {
              name: productName,
              image: productImage,
            },
          });
          document.dispatchEvent(event);
        }

        addToCartForm.style.display = 'none';
        quantityContainer.style.display = 'flex';
        priceTag.style.visibility = 'visible';

        if (window.updateCartDrawer) {
          window.updateCartDrawer();
        }
      } catch (err) {
        console.log(err);
      }
    });

    // Handle quantity increase
    plus.addEventListener('click', async () => {
      // Prevent multiple clicks
      if (isApiCallInProgress) {
        return;
      }
      isApiCallInProgress = true;

      // Visual feedback - disable the button
      plus.classList.add('disabled-button');
      minus.classList.add('disabled-button');

      const max_quantity = parseInt(quantity_input.getAttribute('max'));
      const value = parseInt(quantity_input.innerHTML);
      if (value + 1 > 9 || value + 1 > max_quantity) {
        if (alertBox) {
          const tabElement = alertBox.querySelector('.md-alert');
          const mobileElement = alertBox.querySelector('.mob-alert');
          const item = max_quantity > 1 ? 'items' : 'item';
          mobileElement.innerText = 'Limited Stock!';
          tabElement.innerText = `${max_quantity} ${item} added (limited stock)`;
          if (value + 1 > 9) {
            mobileElement.innerText = 'Max 9 items allowed';
            tabElement.innerText = 'Max 9 items allowed';
          }
          plus.classList.add('disabled-button');
          alertBox.classList.remove('shop-hide-me');
        }
        isApiCallInProgress = false;
        minus.classList.remove('disabled-button');
        return;
      }

      if (value < max_quantity && value + 1 <= 9) {
        quantity_input.innerHTML = value + 1;
        const key = addToCartForm.querySelector('.id-holder-input').getAttribute('data-key');
        const newQuantity = value + 1;
        try {
          await window.handleQuantityChange(key, newQuantity);
        } catch (error) {
          console.error('There was a problem with the fetch operation:', error);
        } finally {
          isApiCallInProgress = false;
          plus.classList.remove('disabled-button');
          minus.classList.remove('disabled-button');
        }
        // await fetch('/cart/change.js', {
        //   method: 'post',
        //   headers: {
        //     'Content-Type': 'application/json',
        //   },
        //   body: JSON.stringify(formData),
        // })
        // .then((response) => {
        //   if (!response.ok) {
        //     throw new Error('Network response was not ok');
        //   }
        //   return response.json();
        // })
        // .then((data) => {
        //   console.log('Cart data->', data);

        //   if (window.updateCartDrawer) {
        //     window.updateCartDrawer();
        //   }
        // })
        // .catch((error) => {
        //   console.error('There was a problem with the fetch operation:', error);
        // });
      }
    });

    // Handle quantity decrease
    minus.addEventListener('click', async () => {
      // Prevent multiple clicks
      if (isApiCallInProgress) {
        return;
      }
      isApiCallInProgress = true;

      minus.classList.add('disabled-button');
      plus.classList.add('disabled-button');

      const key = addToCartForm.querySelector('.id-holder-input').getAttribute('data-key');
      const value = parseInt(quantity_input.innerHTML);
      const max_quantity = parseInt(quantity_input.getAttribute('max'));

      if (parseInt(quantity_input.innerHTML) > 1) {
        quantity_input.innerHTML = parseInt(quantity_input.innerHTML) - 1;
        let newQuantity = parseInt(quantity_input.innerHTML);

        try {
          await window.handleQuantityChange(key, newQuantity);
        } catch (error) {
          console.error('There was a problem with increasing the quantity:', error);
        } finally {
          // Re-enable the buttons
          isApiCallInProgress = false;
          minus.classList.remove('disabled-button');
          if (value <= 9 && value <= max_quantity) {
            plus.classList.remove('disabled-button');
            alertBox.classList.add('shop-hide-me');
          }
        }

        // let formData = {
        //   id: id.innerHTML.toString(),
        //   quantity: parseInt(quantity_input.innerHTML),
        // };
        // await fetch('/cart/change.js', {
        //   method: 'post',
        //   headers: {
        //     'Content-Type': 'application/json',
        //   },
        //   body: JSON.stringify(formData),
        // })
        //   .then((response) => {
        //     if (!response.ok) {
        //       throw new Error('Network response was not ok');
        //     }
        //     return response.json();
        //   })
        //   .then((data) => {
        //     console.log('Cart data->', data);

        //     if (window.updateCartDrawer) {
        //       window.updateCartDrawer();
        //     }
        //   })
        //   .catch((error) => {
        //     console.error('There was a problem with the fetch operation:', error);
        //   });
      } else {
        addToCartForm.style.display = 'flex';
        quantityContainer.style.display = 'none';
        priceTag.style.visibility = 'hidden';
        // let formData = {
        //   id: id.innerHTML.toString(),
        //   quantity: 0,
        // };

        try {
          await window.handleQuantityChange(key, 0);
        } catch (error) {
          console.error('There was a problem decreasing the quantity:', error);
        }
        // await fetch('/cart/change.js', {
        //   method: 'post',
        //   headers: {
        //     'Content-Type': 'application/json',
        //   },
        //   body: JSON.stringify(formData),
        // })
        //   .then((response) => {
        //     if (!response.ok) {
        //       throw new Error('Network response was not ok');
        //     }
        //     return response.json();
        //   })
        //   .then((data) => {
        //     console.log('Cart data->', data);

        //     if (window.updateCartDrawer) {
        //       window.updateCartDrawer();
        //     }
        //   })
        //   .catch((error) => {
        //     console.error('There was a problem with the fetch operation:', error);
        //   });
      }
    });
  });

  // const filterButtons = document.querySelectorAll('.filter-button');
  // const productContainers = document.querySelectorAll('.product-container-wrapper');
  // filterButtons.forEach((button) => {
  //   button.addEventListener('click', () => {
  //     const filterText = button.textContent.trim().toLowerCase();

  //     filterButtons.forEach((btn) => btn.classList.remove('selected'));
  //     button.classList.add('selected');

  //     productContainers.forEach((container) => {
  //       const producrTag = container.querySelector('.product-tag').textContent.trim().toLowerCase()

  //       if (filterText.includes('all') || producrTag === filterText) {
  //         container.style.display = 'flex';
  //       } else {
  //         container.style.display = 'none';
  //       }
  //     });
  //   });
  // });
});


// EventListener to update the item's quantity on the shop pages.
// quantityUpdated - Dispatched from custom-cart-drawer.js
document.addEventListener('quantityUpdated', (e) => {
  const { id, quantity } = e.detail.data;

  // Find the specific card that contains the matching variant-id
  const targetCard = document.querySelector(`[data-variant-id="${id}"]`)?.closest('.product-card');

  // If id is cart line key : Hide the quantity buttons (Item is removed from cart)
  if (typeof id === 'string') {
    const card = document.querySelector(`form input[data-key]`)?.closest('.product-card');
    const addToCartForm = card?.querySelector('form[action="/cart/add"]');
    const quantityContainer = card?.querySelector('.quantity-container');
    const priceTag = card?.querySelector('.price-tag');

    addToCartForm.style.display = 'flex';
    quantityContainer.style.display = 'none';
    priceTag.style.visibility = 'hidden';
    return;
  }
// If id is variant id : Update the quantity
  if (targetCard) {
    const input = targetCard.querySelector('.quantity_input');
    if (input) {
      input.innerHTML = quantity;
    }
  } 
});
